export const TEMPLATE_CONTENT_PLACEHOLDER_ID = '__templateContent';
export const TEMPLATE_CONTENT_PLACEHOLDER_TOKEN = `{{${TEMPLATE_CONTENT_PLACEHOLDER_ID}}}`;

export function isSystemTemplatePlaceholder(id: string): boolean {
	return id === TEMPLATE_CONTENT_PLACEHOLDER_ID;
}

export function composeTemplateContent(parentContent: string | undefined, childContent: string): string | undefined {
	if (!parentContent) {
		return undefined;
	}

	if (parentContent.includes(TEMPLATE_CONTENT_PLACEHOLDER_TOKEN)) {
		return parentContent.split(TEMPLATE_CONTENT_PLACEHOLDER_TOKEN).join(childContent);
	}

	return `${parentContent}${childContent}`;
}
